<template lang="html">
  <div
    class="row"
    :class="{ 'facets-head--on': open }"
    v-if="!collectionMode"
    id="filter"
  >
    <div class="col-12" v-if="facets && facets.length > 0">
      <button class="btn btn-primary facets-head__toggle-btn" @click="toggle">
        <svg class="bi" width="16" height="16" fill="currentColor">
          <use href="../../static/bi-sprite.svg#slider" />
        </svg>
        Vis filter
      </button>
      <div class="facets-head">
        <!-- Facets header  -->
        <a @click="toggle" class="facets-head__toggle">
          <span>
            <svg class="bi" width="16" height="16" fill="currentColor">
              <use href="../../static/bi-sprite.svg#slider" />
            </svg>
            <span class="ml-1">{{ open ? "Skjul filter" : "Vis filter" }}</span>
          </span>
        </a>

        <span class="facets-head__count">
          {{ settings.productsCount }} {{ dict["produkter"] }} |
          {{
            settings.showPricesIncVat
              ? "Priser inkl. moms"
              : "Priser ekskl. moms"
          }}
        </span>
        <span class="facets-head__sort">
          <label for="productorder" class="facets-head__sort-label"
            >Sorter efter:
          </label>
          <select
            class="facets-head__select"
            name="productorder"
            :value="sortOrder"
            @change="onSortOrderChange"
          >
            <option value="default">Standard</option>
            <option value="price-asc">Pris (lav-høj)</option>
            <option value="price-desc">Pris (høj-lav)</option>
            <option value="news">Nyheder</option>
          </select>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "FacetsHead",
  components: {},
  props: ["open"],
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    const desktop = window.matchMedia("(min-width: 768px)").matches;
    if (desktop && this.settings.productsCount > 7) {
      this.toggle(true);
    }
  },
  methods: {
    toggle(toggleTo) {
      toggleTo = typeof toggleTo === "boolean" ? toggleTo : undefined;
      this.$emit("toggle", toggleTo || !this.open);
    },
    onSortOrderChange(e) {
      this.$store.commit("SORTORDER", e.target.value);
      this.$store.dispatch("search", {});
    }
  },
  computed: {
    ...mapState(["facets", "settings", "dict", "collectionMode", "sortOrder"])
  }
});
</script>
